var map = {
	"./Cable.svg": "c538",
	"./FixedLine.svg": "ef61",
	"./Mobile.svg": "dc96",
	"./Unified.svg": "da15",
	"./barring/help_graphical.svg": "7d69",
	"./barring/information_graphical.svg": "72c4",
	"./barring/pinprotection/blocked-user-aktiv.svg": "2dec",
	"./barring/pinprotection/blocked-user-inaktiv.svg": "8a95",
	"./barring/pinprotection/pin-protect-aktiv.svg": "01c3",
	"./barring/pinprotection/pin-protect-inaktiv.svg": "44f4",
	"./barring/status-outline-lock.svg": "42f6",
	"./barring/status-outline-unlock.svg": "0d59",
	"./barring/status-solid-exceptions.svg": "8e78",
	"./barring/status-solid-lock.svg": "f1a6",
	"./barring/status-solid-unlock.svg": "a1ab",
	"./home/auto_topup_registrations.svg": "6622",
	"./home/barring_factoring_status.svg": "7cc8",
	"./home/barring_pin_protection.svg": "ffe5",
	"./home/barring_reselling_status.svg": "2e1f",
	"./home/content_bundles.svg": "0ec8",
	"./home/internal_catalogue.svg": "90dc",
	"./home/internal_stock.svg": "4798",
	"./home/order_overview.svg": "ed16",
	"./home/payment_generation.svg": "f191",
	"./home/payment_transactions.svg": "2176",
	"./home/persistent_confirmations.svg": "64dd",
	"./home/product_catalogue.svg": "8a15",
	"./home/recharge_transactions.svg": "19ab",
	"./home/stock.svg": "3c32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";